import React, { useEffect, useState, useMemo } from "react";
import {
  CreateNewCp,
  generateClientSecret,
  GetCountries,
  getCountryCodeList,
} from "../../../../../api/Api";
import Swal from "sweetalert2";
import { getFromLocalStorage } from "../../../../../utils/common-utils";
import "./createCp.css";

const CreateCp = ({ setCreateCpModal, getAllData, getCount }) => {
  const [createCpForm, setCreateCpForm] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
    username: "",
    password: "",
    mobileNumber: "",
    country: "",
    operator: "",

    companyName: "",
    companyCin: "",
    streetAddress: "",
    cpnyPincode: "",
    cpnyCity: "",
    cpnyState: "",
    cpnyCountry: "",

    businessContactPerson: "",
    businessContactEmail: "",
    businessContactMobile: "",

    financeContactPerson: "",
    financeContactEmail: "",
    financeContactMobile: "",
  });
  console.log("createCpForm", createCpForm);
  const [loaders, setLoaders] = useState({
    countryLoader: false,
  });
  const [countryList, setCountryList] = useState([]);
  const [countryCpList, setCountryCpList] = useState([]);
  const [operatorList, setOperatorList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({
    id: 118,
    iso: "IN",
    name: "INDIA",
    nicename: "India",
    iso3: "IND",
    numcode: 356,
    phonecode: 91,
    currency: "INR",
    msisdnLength: 10,
  });
  console.log("operatorList", operatorList);
  const [error, setError] = useState(false);
  const [profileDetails, setProfileDetails] = useState({});
  const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  const pass = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
  const phoneRegex = /^[6-9]\d{9}$/;
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [searchCountry, setSearchCountry] = useState("");
  const [showBusinessCountryDropdown, setShowBusinessCountryDropdown] =
    useState(false);
  const [selectedBusinessCountry, setSelectedBusinessCountry] = useState({
    id: 118,
    iso: "IN",
    name: "INDIA",
    nicename: "India",
    iso3: "IND",
    numcode: 356,
    phonecode: 91,
    currency: "INR",
    msisdnLength: 10,
  });
  const [showFinanceCountryDropdown, setShowFinanceCountryDropdown] =
    useState(false);

 
  const [selectedFinanceCountry, setSelectedFinanceCountry] = useState({
    id: 118,
    iso: "IN",
    name: "INDIA",
    nicename: "India",
    iso3: "IND",
    numcode: 356,
    phonecode: 91,
    currency: "INR",
    msisdnLength: 10,
  });
  const [showPassword, setShowPassword] = useState(false);

  // Filter countries with null check
  const filteredCountries = useMemo(() => {
    if (!countryList) return [];
    return countryList.filter(
      (country) =>
        country?.name?.toLowerCase().includes(searchCountry.toLowerCase()) ||
        country?.phonecode?.toString().includes(searchCountry)
    );
  }, [countryList, searchCountry]);

  // Set India as default when country list is loaded
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCountryCodeList();
        if (response?.countryList) {
          setCountryList(response.countryList);
          // Find and set India as default
          const india = response.countryList.find(
            (country) => country.iso === "IN"
          );
          if (india) {
            setSelectedCountry(india);
          }
        }
      } catch (error) {
        console.error("Error fetching country list:", error);
        setCountryList([]);
      }
    };

    fetchData();
  }, []);

  // create cp
  const handleSubmit = async (e) => {
    e.preventDefault();
    const {
      firstName,
      lastName,
      emailId,
      username,
      password,
      mobileNumber,
      // country,
      // operator,
      companyName,
      companyCin,
      streetAddress,
      cpnyPincode,
      cpnyCity,
      cpnyState,
      cpnyCountry,

      businessContactPerson,
      businessContactEmail,
      businessContactMobile,

      financeContactPerson,
      financeContactEmail,
      financeContactMobile,
    } = createCpForm;
    if (
      !firstName ||
      !lastName ||
      !emailId ||
      !emailRegex.test(emailId) ||
      !username ||
      !password ||
      !pass.test(password) ||
      !mobileNumber ||
      (mobileNumber && !phoneRegex.test(mobileNumber)) 
      // ||
      // !country ||
      // !operator ||
      ||
      !companyName ||
      !companyCin ||
      !streetAddress ||
      !cpnyPincode ||
      !cpnyCity ||
      !cpnyState ||
      !cpnyCountry ||
      !businessContactPerson ||
      !businessContactEmail ||
      !emailRegex.test(businessContactEmail) ||
      !businessContactMobile ||
      !phoneRegex.test(businessContactMobile) ||
      !financeContactPerson ||
      !financeContactEmail ||
      !emailRegex.test(financeContactEmail) ||
      !financeContactMobile
    ) {
      setError(true);
    } else {
      setError(false);
      if (selectedFinanceCountry && createCpForm.financeContactMobile) {
        const formattedFinanceMobile = `+${selectedFinanceCountry.phonecode}${createCpForm.financeContactMobile}`;

        let payload = {
          firstName: firstName,
          lastName: lastName,
          email: emailId,
          username: username,
          passwd: password,
          mobileNo: `+${selectedCountry.phonecode}${mobileNumber}`,
          // countryName: Number(country),
          // operatorNameList: [Number(operator)],
          userId: getFromLocalStorage("userData")?.id,
          cpDetailsList: [
            {
              companyName: companyName,
              companyAddress: streetAddress,
              companyCin: companyCin,
              streetAddress: streetAddress,
              city: cpnyCity,
              state: cpnyState,
              // country: cpnyCountry,
              zipcode: cpnyPincode,
              companyRegistrationDoc: "",

              businessContactPerson: businessContactPerson,
              businessContactNumber: `+${selectedBusinessCountry.phonecode}${businessContactMobile}`,
              businessContactEmail: businessContactEmail,

              financeContactPerson: financeContactPerson,
              financeContactNumber: formattedFinanceMobile,
              financeContactEmail: financeContactEmail,
            },
          ],
        };
        console.log("responseCreateCp", payload);
        const response = await CreateNewCp(payload);
        console.log("responseCreateCpreeee", response);
        if (response?.statusDescription?.status == 200) {
          const cpId = response.contentProvider.id;
          const secretResponse = await generateClientSecret(cpId);
          console.log("secretResponse", secretResponse);
          getAllData();
          getCount();
          Swal.fire({
            icon: "success",
            text: response?.statusDescription?.description,
            confirmButtonText: "OK",
          });
          setCreateCpModal(false);
          setCreateCpForm({
            firstName: "",
            lastName: "",
            emailId: "",
            username: "",
            password: "",
            mobileNumber: "",
            // country: "",
            // operator: "",

            companyName: "",
            companyCin: "",
            streetAddress: "",
            cpnyPincode: "",
            cpnyCity: "",
            cpnyState: "",
            cpnyCountry: "",

            businessContactPerson: "",
            businessContactEmail: "",
            businessContactMobile: "",

            financeContactPerson: "",
            financeContactEmail: "",
            financeContactMobile: "",
          });
        } else {
          Swal.fire({
            icon: "info",
            text: response?.statusDescription?.description,
            confirmButtonText: "OK",
          });
        }
      }
    }
  };

  const getCountriesAndOperators = async () => {
    setLoaders((prev) => ({ ...prev, countryLoader: true }));
    const response = await GetCountries();
    console.log("response12", response);
    if (response?.statusDescription?.status == 200) {
      setCountryCpList(response?.countryResponseList);
    } else {
      setCountryCpList([]);
    }
    setLoaders((prev) => ({ ...prev, countryLoader: false }));
  };

  useEffect(() => {
    getCountriesAndOperators();
  }, []);
  const handleCountryChange = (e) => {
    const country = countryList.find((c) => c.countryName === e.target.value);
    setSelectedCountry(country);
  };

  console.log("couttrrr", countryList);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".phone-input-container")) {
        setShowFinanceCountryDropdown(false);
        setShowBusinessCountryDropdown(false);
        setShowCountryDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  console.log("selectedBusinessCountry", selectedBusinessCountry);
  return (
    <form class="form-horizontal" onSubmit={handleSubmit}>
      <div className="card mt-4 position-relative">
        <span className="mt-2 mb-3 fw-bold badge_head text-center">
          Personal Information
        </span>
        <div class="row  mb-1 pt-4 px-4">
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class="">
                First Name<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.firstName ? "is-invalid" : ""
                  }`}
                maxlength="100"
                name="firstName"
                placeholder="First Name"
                autocomplete="FirstName"
                value={createCpForm.firstName}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    firstName: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.firstName && (
                <div class="invalid-feedback d-block error">
                  <div>First Name is required.</div>
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class="">
                Last Name<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.lastName ? "is-invalid" : ""
                  }`}
                autocomplete="LastName"
                placeholder="Last Name"
                maxlength="30"
                name="lastName"
                value={createCpForm.lastName}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    lastName: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.lastName && (
                <div class="invalid-feedback d-block error">
                  <div>Last Name is required.</div>
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class="">
                Email Id<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.emailId ? "is-invalid" : ""
                  }`}
                autocomplete="EmailId"
                placeholder="Email Id"
                maxlength="70"
                name="emailId"
                value={createCpForm.emailId}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    emailId: e.target.value,
                  }))
                }
              />
              {error &&
                (!createCpForm.emailId ||
                  !emailRegex.test(createCpForm.emailId)) && (
                  <div className="invalid-feedback d-block error">
                    {!createCpForm.emailId
                      ? "Please enter an email id"
                      : createCpForm.emailId &&
                        !emailRegex.test(createCpForm.emailId)
                        ? "Please enter a valid email id"
                        : ""}
                  </div>
                )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class="">
                Username<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.username ? "is-invalid" : ""
                  }`}
                autocomplete="username"
                placeholder="Username"
                maxlength="70"
                name="username"
                value={createCpForm.username}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    username: e.target.value,
                  }))
                }
              />
              {error && !createCpForm.username && (
                <div className="invalid-feedback d-block error">
                  Please enter an username
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class="">
                Password<sup class="text-danger">*</sup>
              </label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  class={`form-control ${error &&
                      (!createCpForm.password ||
                        !pass.test(createCpForm.password))
                      ? "is-invalid"
                      : ""
                    }`}
                  autocomplete="nope"
                  // autocomplete="Password"
                  placeholder="Password"
                  name="password"
                  maxLength={50}
                  value={createCpForm.password}
                  onChange={(e) =>
                    setCreateCpForm((prev) => ({
                      ...prev,
                      password: e.target.value,
                    }))
                  }
                />
                <span
                  className="input-group-text"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={`fas fa-eye${showPassword ? "" : "-slash"}`}
                  ></i>
                </span>
              </div>
              {error &&
                (!createCpForm.password ||
                  !pass.test(createCpForm.password)) && (
                  <div className="invalid-feedback d-block error">
                    {!createCpForm.password
                      ? "Please enter a password"
                      : createCpForm.password &&
                        !pass.test(createCpForm.password)
                        ? "Password must has at least 8 characters that include at least 1 lowercase character, 1 uppercase characters, 1 number, and 1 special character"
                        : ""}
                  </div>
                )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class="">
                Mobile<sup class="text-danger">*</sup>
              </label>
              <div className="phone-input-container">
                <div
                  className="phone-select"
                  onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                >
                  {selectedCountry && (
                    <>
                      <img
                        src={`https://flagcdn.com/w20/${selectedCountry?.iso?.toLowerCase()}.png`}
                        alt={selectedCountry?.name}
                        className="flag-icon"
                      />
                      <span className="country-code">
                        +{selectedCountry?.phonecode}
                      </span>
                      <i className="fas fa-chevron-down arrow-icon"></i>
                    </>
                  )}
                </div>
                <input
                  type="text"
                  className={`form-control mobile-input ${error &&
                      (!createCpForm.mobileNumber ||
                        !phoneRegex.test(createCpForm.mobileNumber))
                      ? "is-invalid"
                      : ""
                    }`}
                  placeholder={`Enter ${selectedCountry?.msisdnLength || 10
                    } digit number`}
                  maxLength={selectedCountry?.msisdnLength || 10}
                  value={createCpForm.mobileNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (
                      selectedCountry &&
                      value.length <= selectedCountry.msisdnLength
                    ) {
                      setCreateCpForm((prev) => ({
                        ...prev,
                        mobileNumber: value,
                      }));
                    }
                  }}
                />

                {showCountryDropdown && (
                  <div className="country-dropdown">
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search country..."
                      value={searchCountry}
                      onChange={(e) => setSearchCountry(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <div className="country-list">
                      {filteredCountries.map((country) => (
                        <div
                          key={country?.id}
                          className="country-item"
                          onClick={() => {
                            if (country) {
                              setSelectedCountry(country);
                              setShowCountryDropdown(false);
                              setSearchCountry("");
                              setCreateCpForm((prev) => ({
                                ...prev,
                                mobileNumber: "",
                              }));
                            }
                          }}
                        >
                          <img
                            src={`https://flagcdn.com/w20/${country?.iso?.toLowerCase()}.png`}
                            alt={country?.name}
                            className="flag-icon"
                          />
                          <span className="country-name">{country?.name}</span>
                          <span className="country-code">
                            +{country?.phonecode}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              {error &&
                (!createCpForm.mobileNumber ||
                  !phoneRegex.test(createCpForm.mobileNumber)) && (
                  <div className="invalid-feedback d-block">
                    {!createCpForm.mobileNumber
                      ? "Please enter a mobile number"
                      : "Please enter a valid mobile number"}
                  </div>
                )}
              {/* <small className="form-text text-muted">
              Enter {selectedCountry?.msisdnLength || 10} digit mobile number
            </small> */}
            {/* </div> */}
          </div>
        </div>

        {/* <div class="row px-4">
          
          <div class="col-sm-3">
            <div class="form-group">
              <label class="font-weight-bold">
                Password<sup class="text-danger">*</sup>
              </label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  class={`form-control ${error &&
                      (!createCpForm.password ||
                        !pass.test(createCpForm.password))
                      ? "is-invalid"
                      : ""
                    }`}
                  autocomplete="nope"
                  placeholder="Password"
                  name="password"
                  maxLength={50}
                  value={createCpForm.password}
                  onChange={(e) =>
                    setCreateCpForm((prev) => ({
                      ...prev,
                      password: e.target.value,
                    }))
                  }
                />
                <span
                  className="input-group-text"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={`fas fa-eye${showPassword ? "" : "-slash"}`}
                  ></i>
                </span>
              </div>
              {error &&
                (!createCpForm.password ||
                  !pass.test(createCpForm.password)) && (
                  <div className="invalid-feedback d-block error">
                    {!createCpForm.password
                      ? "Please enter a password"
                      : createCpForm.password &&
                        !pass.test(createCpForm.password)
                        ? "Password must has at least 8 characters that include at least 1 lowercase character, 1 uppercase characters, 1 number, and 1 special character"
                        : ""}
                  </div>
                )}
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label class="font-weight-bold">
                Mobile<sup class="text-danger">*</sup>
              </label>
              <div className="phone-input-container">
                <div
                  className="phone-select"
                  onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                >
                  {selectedCountry && (
                    <>
                      <img
                        src={`https://flagcdn.com/w20/${selectedCountry?.iso?.toLowerCase()}.png`}
                        alt={selectedCountry?.name}
                        className="flag-icon"
                      />
                      <span className="country-code">
                        +{selectedCountry?.phonecode}
                      </span>
                      <i className="fas fa-chevron-down arrow-icon"></i>
                    </>
                  )}
                </div>
                <input
                  type="text"
                  className={`form-control mobile-input ${error &&
                      (!createCpForm.mobileNumber ||
                        !phoneRegex.test(createCpForm.mobileNumber))
                      ? "is-invalid"
                      : ""
                    }`}
                  placeholder={`Enter ${selectedCountry?.msisdnLength || 10
                    } digit number`}
                  maxLength={selectedCountry?.msisdnLength || 10}
                  value={createCpForm.mobileNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (
                      selectedCountry &&
                      value.length <= selectedCountry.msisdnLength
                    ) {
                      setCreateCpForm((prev) => ({
                        ...prev,
                        mobileNumber: value,
                      }));
                    }
                  }}
                />

                {showCountryDropdown && (
                  <div className="country-dropdown">
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search country..."
                      value={searchCountry}
                      onChange={(e) => setSearchCountry(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <div className="country-list">
                      {filteredCountries.map((country) => (
                        <div
                          key={country?.id}
                          className="country-item"
                          onClick={() => {
                            if (country) {
                              setSelectedCountry(country);
                              setShowCountryDropdown(false);
                              setSearchCountry("");
                              setCreateCpForm((prev) => ({
                                ...prev,
                                mobileNumber: "",
                              }));
                            }
                          }}
                        >
                          <img
                            src={`https://flagcdn.com/w20/${country?.iso?.toLowerCase()}.png`}
                            alt={country?.name}
                            className="flag-icon"
                          />
                          <span className="country-name">{country?.name}</span>
                          <span className="country-code">
                            +{country?.phonecode}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              {error &&
                (!createCpForm.mobileNumber ||
                  !phoneRegex.test(createCpForm.mobileNumber)) && (
                  <div className="invalid-feedback d-block">
                    {!createCpForm.mobileNumber
                      ? "Please enter a mobile number"
                      : "Please enter a valid mobile number"}
                  </div>
                )}
            
            </div>
          </div> */}


          
          {/* <div class="col-sm-3">
            <div class="form-group">
              <label class="font-weight-bold">
                Select Country <sup class="text-danger">*</sup>
              </label>
              <div className="position-relative">
                <select
                  class={`form-control ${error && !createCpForm.country ? "is-invalid" : ""
                    }`}
                  name="country"
                  formControlName="country"
                  value={createCpForm.country}
                  onChange={(e) => {
                    const selectedCountryId = e.target.value;
                    const selectedCountry = countryCpList?.find(
                      (country) =>
                        country?.id === Number(selectedCountryId) ||
                        country?.id === selectedCountryId
                    );
                    console.log("Selected country:", selectedCountry);
                    if (
                      selectedCountry &&
                      Array.isArray(selectedCountry.operatorList)
                    ) {
                      setOperatorList(selectedCountry.operatorList);
                    } else {
                      setOperatorList([]);
                      console.log(
                        "No operator list found for selected country"
                      );
                    }
                    setCreateCpForm({
                      ...createCpForm,
                      country: selectedCountryId,
                      operator: "",
                    });
                  }}
                  disabled={loaders.countryLoader}
                >
                  <option value="" selected>
                    {loaders.countryLoader
                      ? "Loading countries..."
                      : "--Select Country --"}
                  </option>
                  {!loaders.countryLoader &&
                    countryCpList &&
                    countryCpList?.map((item) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.countryName}
                      </option>
                    ))}
                </select>
                {loaders.countryLoader && (
                  <span className="sr-only">Loading...</span>
                )}
                <div className="dropdown-icon">
                  <i
                    className="fas fa-chevron-down"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      display: loaders.countryLoader ? "none" : "block",
                    }}
                  ></i>
                </div>
              </div>
              {error && !createCpForm.country && (
                <span class="invalid-feedback d-block error">
                  Country is required
                </span>
              )}
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label class="font-weight-bold">
                Select Operator <sup class="text-danger">*</sup>
              </label>
              <div className="position-relative">
                <select
                  class={`form-control ${error && !createCpForm.operator ? "is-invalid" : ""
                    }`}
                  name="operator"
                  formControlName="operator"
                  value={createCpForm.operator}
                  onChange={(e) =>
                    setCreateCpForm({
                      ...createCpForm,
                      operator: e.target.value,
                    })
                  }
                >
                  <option value="" selected>
                    --Select Operator --
                  </option>
                  {operatorList &&
                    operatorList?.map((item) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.operatorName}
                      </option>
                    ))}
                </select>
                <div className="dropdown-icon">
                  <i
                    className="fas fa-chevron-down"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      display: loaders.countryLoader ? "none" : "block",
                    }}
                  ></i>
                </div>
              </div>
              {error && !createCpForm.operator && (
                <span class="invalid-feedback d-block error">
                  Operator is required
                </span>
              )}
            </div>
          </div> */}



        {/* </div> */}

       
      </div>

      <div className="card mt-5 position-relative">
        <span className="mt-2 mb-3 fw-bold badge_head text-center">Company Information</span>
        <div class="row mb-1  pt-4 px-4">
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                Company Name<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.companyName ? "is-invalid" : ""
                  }`}
                autocomplete="companyAdd"
                placeholder="Company Address"
                maxlength={100}
                name="companyAdd"
                value={createCpForm.companyName}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    companyName: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.companyName && (
                <div class="invalid-feedback d-block error">
                  Please enter a company name
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                Company Cin<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.companyCin ? "is-invalid" : ""
                  }`}
                autocomplete="companyCin"
                placeholder="Company Cin"
                maxlength={30}
                name="companyCin"
                value={createCpForm.companyCin}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    companyCin: e.target.value,
                  }))
                }
              />
              {error && !createCpForm.companyCin && (
                <div class="invalid-feedback d-block error">
                  Please enter a company cin
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class=" ">
                Street Address<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.streetAddress ? "is-invalid" : ""
                  }`}
                autocomplete="streetAddress"
                placeholder="Street Address"
                maxlength={30}
                name="streetAddress"
                value={createCpForm.streetAddress}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    streetAddress: e.target.value,
                  }))
                }
              />
              {error && !createCpForm.streetAddress && (
                <div class="invalid-feedback d-block error">
                  Please enter a street address
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                Pincode<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.cpnyPincode ? "is-invalid" : ""
                  }`}
                autocomplete="cpnyPincode"
                placeholder="Pincode"
                maxlength={6}
                name="cpnyPincode"
                value={createCpForm.cpnyPincode}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    cpnyPincode: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (
                    /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/.test(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.cpnyPincode && (
                <div class="invalid-feedback d-block error">
                  Please enter a pincode
                </div>
              )}
            {/* </div> */}
          </div>
        </div>

        <div class="row px-4">
          
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                City<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.cpnyCity ? "is-invalid" : ""
                  }`}
                autocomplete="cpnyCity"
                placeholder="City"
                maxlength={30}
                name="cpnyCity"
                value={createCpForm.cpnyCity}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    cpnyCity: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.cpnyCity && (
                <div class="invalid-feedback d-block error">
                  Please enter a city
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                State<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.cpnyState ? "is-invalid" : ""
                  }`}
                autocomplete="cpnyState"
                placeholder="State"
                maxlength={30}
                name="cpnyState"
                value={createCpForm.cpnyState}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    cpnyState: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.cpnyState && (
                <div class="invalid-feedback d-block error">
                  Please enter a state
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label class="">
                Country <sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.cpnyCountry ? "is-invalid" : ""
                  }`}
                autocomplete="cpnyCountry"
                placeholder="Country"
                maxlength={30}
                name="cpnyCountry"
                value={createCpForm.cpnyCountry}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    cpnyCountry: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.cpnyCountry && (
                <div class="invalid-feedback d-block error">
                  Please enter a country
                </div>
              )}
            {/* </div> */}
          </div>
        </div>

      
      </div>

      <div className="card mt-5 position-relative">
        <span className="mt-2 mb-3 fw-bold badge_head text-center">Business Information</span>
        <div class="row  mb-1  pt-4 px-4">
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                Contact person<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.businessContactPerson ? "is-invalid" : ""
                  }`}
                autocomplete="businessContactPerson"
                placeholder="Business Contact Person"
                maxlength={30}
                name="businessContactPerson"
                value={createCpForm.businessContactPerson}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    businessContactPerson: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.businessContactPerson && (
                <div class="invalid-feedback d-block error">
                  Please enter a business contact person
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                Contact Email<sup class="text-danger">*</sup>
              </label>
              <input
                type="email"
                class={`form-control ${error &&
                    (!createCpForm.businessContactEmail ||
                      !emailRegex.test(createCpForm.businessContactEmail))
                    ? "is-invalid"
                    : ""
                  }`}
                autocomplete="BusContactMail"
                placeholder="Business Contact Email"
                maxlength={100}
                name="BusContactMail"
                value={createCpForm.businessContactEmail}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    businessContactEmail: e.target.value,
                  }))
                }
              />
              {error &&
                (!createCpForm.businessContactEmail ||
                  !emailRegex.test(createCpForm.businessContactEmail)) && (
                  <div class="invalid-feedback d-block error">
                    {!createCpForm.businessContactEmail
                      ? "Please enter a business contact email"
                      : createCpForm.businessContactEmail &&
                        !emailRegex.test(createCpForm.businessContactEmail)
                        ? "Please enter a valid business contact email"
                        : ""}
                  </div>
                )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                Contact Number<sup class="text-danger">*</sup>
              </label>
              <div className="phone-input-container">
                <div
                  className="phone-select"
                  onClick={() =>
                    setShowBusinessCountryDropdown(!showBusinessCountryDropdown)
                  }
                >
                  {selectedBusinessCountry && (
                    <>
                      <img
                        src={`https://flagcdn.com/w20/${selectedBusinessCountry?.iso?.toLowerCase()}.png`}
                        alt={selectedBusinessCountry?.name}
                        className="flag-icon"
                      />
                      <span className="country-code">
                        +{selectedBusinessCountry?.phonecode}
                      </span>
                      <i className="fas fa-chevron-down arrow-icon"></i>
                    </>
                  )}
                </div>
                <input
                  type="text"
                  className={`form-control mobile-input ${error &&
                      (!createCpForm.businessContactMobile ||
                        !phoneRegex.test(createCpForm.businessContactMobile))
                      ? "is-invalid"
                      : ""
                    }`}
                  placeholder={`Enter ${selectedBusinessCountry?.msisdnLength || 10
                    } digit number`}
                  maxLength={selectedBusinessCountry?.msisdnLength || 10}
                  name="BusContactNumber"
                  value={createCpForm.businessContactMobile}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (
                      selectedBusinessCountry &&
                      value.length <= selectedBusinessCountry.msisdnLength
                    ) {
                      setCreateCpForm((prev) => ({
                        ...prev,
                        businessContactMobile: value,
                      }));
                    }
                  }}
                />

                {showBusinessCountryDropdown && (
                  <div className="country-dropdown">
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search country..."
                      value={searchCountry}
                      onChange={(e) => setSearchCountry(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <div className="country-list">
                      {filteredCountries
                        .filter(
                          (country) =>
                            country?.name
                              ?.toLowerCase()
                              .includes(searchCountry.toLowerCase()) ||
                            country?.phonecode?.toString().includes(searchCountry)
                        )
                        .map((country) => (
                          <div
                            key={country?.id}
                            className="country-item"
                            onClick={() => {
                              if (country) {
                                setSelectedBusinessCountry(country);
                                setShowBusinessCountryDropdown(false);
                                setSearchCountry("");
                                setCreateCpForm((prev) => ({
                                  ...prev,
                                  businessContactMobile: "",
                                }));
                              }
                            }}
                          >
                            <img
                              src={`https://flagcdn.com/w20/${country?.iso?.toLowerCase()}.png`}
                              alt={country?.name}
                              className="flag-icon"
                            />
                            <span className="country-name">{country?.name}</span>
                            <span className="country-code">
                              +{country?.phonecode}
                            </span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
              {error &&
                (!createCpForm.businessContactMobile ||
                  !phoneRegex.test(createCpForm.businessContactMobile)) && (
                  <div className="invalid-feedback d-block error">
                    {!createCpForm.businessContactMobile
                      ? "Please enter a business contact number"
                      : "Please enter a valid business contact number"}
                  </div>
                )}
            {/* </div> */}
          </div>
        </div>
      </div>

      <div className="card mt-5 position-relative">
        <span className="mt-2 mb-3 fw-bold badge_head text-center">Finance Information</span>
        <div class="row mb-1 pt-4 px-4">
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                Contact Person<sup class="text-danger">*</sup>
              </label>
              <input
                type="text"
                class={`form-control ${error && !createCpForm.financeContactPerson ? "is-invalid" : ""
                  }`}
                autocomplete="financeContactPerson"
                placeholder="Finance Contact Person"
                maxlength={30}
                name="financeContactPerson"
                value={createCpForm.financeContactPerson}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    financeContactPerson: e.target.value,
                  }))
                }
                onKeyPress={(e) => {
                  if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {error && !createCpForm.financeContactPerson && (
                <div class="invalid-feedback d-block error">
                  Please enter a finance contact person
                </div>
              )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                 Contact Email<sup class="text-danger">*</sup>
              </label>
              <input
                type="email"
                class={`form-control ${error &&
                    (!createCpForm.financeContactEmail ||
                      !emailRegex.test(createCpForm.financeContactEmail))
                    ? "is-invalid"
                    : ""
                  }`}
                autocomplete="FinanceContactEmail"
                placeholder="Finance Contact Email"
                maxlength={100}
                name="FinanceContactEmail"
                value={createCpForm.financeContactEmail}
                onChange={(e) =>
                  setCreateCpForm((prev) => ({
                    ...prev,
                    financeContactEmail: e.target.value,
                  }))
                }
              />
              {error &&
                (!createCpForm.financeContactEmail ||
                  !emailRegex.test(createCpForm.financeContactEmail)) && (
                  <div class="invalid-feedback d-block error">
                    {!createCpForm.financeContactEmail
                      ? "Please enter a finance contact email"
                      : createCpForm.financeContactEmail &&
                        !emailRegex.test(createCpForm.financeContactEmail)
                        ? "Please enter a valid finance contact email"
                        : ""}
                  </div>
                )}
            {/* </div> */}
          </div>
          <div class="form-group col-sm-3">
            {/* <div class="form-group"> */}
              <label>
                 Contact Number<sup class="text-danger">*</sup>
              </label>
              <div className="phone-input-container">
                <div
                  className="phone-select"
                  onClick={() =>
                    setShowFinanceCountryDropdown(!showFinanceCountryDropdown)
                  }
                >
                  {selectedFinanceCountry && (
                    <>
                      <img
                        src={`https://flagcdn.com/w20/${selectedFinanceCountry?.iso?.toLowerCase()}.png`}
                        alt={selectedFinanceCountry?.name}
                        className="flag-icon"
                      />
                      <span className="country-code">
                        +{selectedFinanceCountry?.phonecode}
                      </span>
                      <i className="fas fa-chevron-down arrow-icon"></i>
                    </>
                  )}
                </div>
                <input
                  type="text"
                  className={`form-control mobile-input ${error &&
                      (!createCpForm.financeContactMobile ||
                        !phoneRegex.test(createCpForm.financeContactMobile))
                      ? "is-invalid"
                      : ""
                    }`}
                  placeholder={`Enter ${selectedFinanceCountry?.msisdnLength || 10
                    } digit number`}
                  maxLength={selectedFinanceCountry?.msisdnLength || 10}
                  name="financeContactNum"
                  value={createCpForm.financeContactMobile}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (
                      selectedFinanceCountry &&
                      value.length <= selectedFinanceCountry.msisdnLength
                    ) {
                      setCreateCpForm((prev) => ({
                        ...prev,
                        financeContactMobile: value,
                      }));
                    }
                  }}
                />

                {showFinanceCountryDropdown && (
                  <div className="country-dropdown">
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search country..."
                      value={searchCountry}
                      onChange={(e) => setSearchCountry(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <div className="country-list">
                      {filteredCountries
                        .filter(
                          (country) =>
                            country?.name
                              ?.toLowerCase()
                              .includes(searchCountry.toLowerCase()) ||
                            country?.phonecode?.toString().includes(searchCountry)
                        )
                        .map((country) => (
                          <div
                            key={country?.id}
                            className="country-item"
                            onClick={() => {
                              if (country) {
                                setSelectedFinanceCountry(country);
                                setShowFinanceCountryDropdown(false);
                                setSearchCountry("");
                                setCreateCpForm((prev) => ({
                                  ...prev,
                                  financeContactMobile: "",
                                }));
                              }
                            }}
                          >
                            <img
                              src={`https://flagcdn.com/w20/${country?.iso?.toLowerCase()}.png`}
                              alt={country?.name}
                              className="flag-icon"
                            />
                            <span className="country-name">{country?.name}</span>
                            <span className="country-code">
                              +{country?.phonecode}
                            </span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
              {error &&
                (!createCpForm.financeContactMobile ||
                  !phoneRegex.test(createCpForm.financeContactMobile)) && (
                  <div className="invalid-feedback d-block error">
                    {!createCpForm.financeContactMobile
                      ? "Please enter a finance contact number"
                      : "Please enter a valid finance contact number"}
                  </div>
                )}
            {/* </div> */}
          </div>
        </div>
      </div>
      <div class="modal-footer pb-0 border-0 justify-content-between mx-0 px-0">
        <button
          type="button"
          class="btn btn-danger btn-raised m-0"
          data-dismiss="modal"
          onClick={() => {
            setCreateCpModal(false);
            setError(false);
            setCreateCpForm({
              firstName: "",
              lastName: "",
              emailId: "",
              password: "",
              mobileNumber: "",
              companyName: "",
              companyCin: "",
              streetAddress: "",
              city: "",
              state: "",
              country: "",
              businessContactPerson: "",
              businessContactEmail: "",
              businessContactMobile: "",
              financeContactPerson: "",
              financeContactEmail: "",
              financeContactMobile: "",
              operator: "",
            });
          }}
        >
          Cancel
        </button>
        <button type="submit" class="btn btn-primary btn-raised m-0">
          Submit
        </button>
      </div>
    </form>
  );
};

export default CreateCp;
